import React from "react";
import { PageTitle, Paragraph, ParaTitle, Pagination, ParaImageDialog } from "../common";
import { Typography } from "@mui/material";

const DashboardReports = () => {
  return (
    <div>
      <PageTitle title='Dashboard Reports' role='Risk Manager' />
      <ParaTitle paraTitle='How To Start' />
      <Paragraph paragraph='Admins/Approvers have access to many kinds of reports which are in graph and text formats regarding the events, locations and categories.' />

      <ParaTitle paraTitle='Dashboard Reports' />
      <Paragraph paragraph='The dashboard reports are visible in the home page. The graph reports on the dashboard hold up to 5 data types. Aside from the graphical information that is displayed automatically there are two main features that are part of the dashboard reports.' />
      <ol>
        <Typography variant="body1" component="li">Users can click the blue bar above a graph and get a text report that includes data types that were not in the graphs which hold up to 5 types.</Typography>
        <Typography variant="body1" component="li">Users can click the icon/data type name in the legend of some of the graphs to omit that particular data type from the graph. Access User Management.</Typography>
      </ol>
      <ParaImageDialog src='/tutorial_image/dashboard-reports-1.png' />
      
      <Pagination
        pagination={{
          prev: { name: 'Facility Management', link: '/organization-manager/facility-management' },
          next: { name: 'Graphical Reports', link: '/reports/graphical-reports' }
        }}
      />
      {/* &#39; */}
    </div>
  );
};

export default DashboardReports;
